"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveAppointmentGap = exports.SAVE_APPOINTMENT = void 0;
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _myAppointmentApi = require("../../../csc/api/myAppointmentApi");
var _myAppointmentTypes = require("../../types/myAppointmentTypes");
var _myAppointmentGapLoadAction = require("./myAppointmentGapLoadAction");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var SAVE_APPOINTMENT = exports.SAVE_APPOINTMENT = 'api/reducer/SAVE_APPOINTMENT';
var myAppointmentSaveAction = {
  data: (0, _propTypes.shape)({
    innerData: _propTypes.default.shape(_myAppointmentTypes.appointmentGapPropType).isRequired
  }).isRequired,
  type: _propTypes.default.string.isRequired
};
var saveAppointmentGap = exports.saveAppointmentGap = function saveAppointmentGap(dispatch, contractAccountId, assOrderId, appointmentGap) {
  return new Promise(function (resolve, reject) {
    if (contractAccountId && assOrderId && (appointmentGap === null || appointmentGap === void 0 ? void 0 : appointmentGap.gapId)) {
      dispatch({
        type: _myAppointmentGapLoadAction.SET_APPOINTMENT_LOADING
      });
      (0, _myAppointmentApi.saveAppointment)(contractAccountId, assOrderId, appointmentGap === null || appointmentGap === void 0 ? void 0 : appointmentGap.gapId).then(function () {
        var responseNextAppointmentPromise = (0, _myAppointmentApi.getNextAppointment)(contractAccountId, assOrderId);
        responseNextAppointmentPromise.then(function (responseAppointment) {
          dispatch({
            type: SAVE_APPOINTMENT,
            data: {
              assOrderId: assOrderId,
              innerData: responseAppointment.data
            }
          });
        });
        resolve(true);
      }).catch(function (error) {
        var _error$response;
        dispatch({
          type: _myAppointmentGapLoadAction.THROW_APPOINTMENT_ERROR
        });
        if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 422) {
          resolve(false);
        } else {
          reject(false);
        }
      });
    } else {
      reject(false);
    }
  });
};